import React, { useState } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";

function CompetitorPromoConsumers({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isUploading, setIsUploading] = useState(false);
  const [isError, setIsError] = useState({});

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        consumer_promo_photo_temp_path: uploadResult.temp_path
      }));
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") return; // photos handled by handlePhotoUpload
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      navigation.go("competitor-promo-merchant");
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">
                COMPETITOR PROMO FOR CONSUMERS
              </h4>
              <p className="form-desc">
                Please provide competitor promotion information for consumers
              </p>
            </div>
            
            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Consumer Promo (TITLE)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="consumer_promo_title"
                      value={primaryDetails.consumer_promo_title || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Consumer Promo (ACQUIRER)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="consumer_promo_acquirer"
                      value={primaryDetails.consumer_promo_acquirer || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Consumer Promo (PROMO MECHANICS)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="consumer_promo_mechanics"
                      value={primaryDetails.consumer_promo_mechanics || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Consumer Promo (DURATION)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="consumer_promo_duration"
                      value={primaryDetails.consumer_promo_duration || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Consumer Promo Photo
                      {primaryDetails.consumer_promo_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                  </Form.Group>

                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CompetitorPromoConsumers;